import { render } from "./AnalysisCard.vue?vue&type=template&id=b54a95ee&scoped=true"
import script from "./AnalysisCard.vue?vue&type=script&lang=js"
export * from "./AnalysisCard.vue?vue&type=script&lang=js"

import "./AnalysisCard.vue?vue&type=style&index=0&id=b54a95ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b54a95ee"]])

export default __exports__